import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const INVITE_STAFF_MEMBER = 'INVITE_STAFF_MEMBER'
const UPDATE_STAFF_ROLE = 'UPDATE_STAFF_ROLE'
const REMOVE_STAFF_MEMBER = 'REMOVE_STAFF_MEMBER'
const CANCEL_INVITATION = 'CANCEL_INVITATION'
const ACCEPT_INVITATION = 'ACCEPT_INVITATION'
const UPDATE_AUTHOR_PROFILE = 'UPDATE_AUTHOR_PROFILE'

export const inviteStaffMemberApi = apiCall(
  INVITE_STAFF_MEMBER,
  ({
    siteId,
    email,
    role,
  }: {
    siteId: string
    email: string
    role: string
  }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/staff/invite`),
    method: 'POST',
    headers: appApiHeaders(),
    body: { email, role },
  })
)

export const updateStaffRoleApi = apiCall(
  UPDATE_STAFF_ROLE,
  ({ siteId, userId, role }: { siteId: string; userId: string; role: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/staff/${userId}`),
    method: 'PATCH',
    headers: appApiHeaders(),
    body: { role },
  })
)

export const removeStaffMemberApi = apiCall(
  REMOVE_STAFF_MEMBER,
  ({
    siteId,
    userId,
    reassignToUserId,
  }: {
    siteId: string
    userId: string
    reassignToUserId?: string
  }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/staff/${userId}`),
    method: 'DELETE',
    headers: appApiHeaders(),
    body: reassignToUserId ? { reassignToUserId } : undefined,
  })
)

export const cancelInvitationApi = apiCall(
  CANCEL_INVITATION,
  ({ siteId, invitationId }: { siteId: string; invitationId: string }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/invitations/sites/${siteId}/${invitationId}`
    ),
    method: 'DELETE',
    headers: appApiHeaders(),
  })
)

export const acceptInvitationApi = apiCall(
  ACCEPT_INVITATION,
  ({ token }: { token: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/account/invitations/${token}/accept`),
    method: 'POST',
    headers: appApiHeaders(),
  })
)

export const updateAuthorProfileApi = apiCall(
  UPDATE_AUTHOR_PROFILE,
  ({
    siteId,
    userId,
    data,
  }: {
    siteId: string
    userId: string
    data: {
      name?: string
      bio?: string
      avatar?: string
      website?: string
      twitter?: string
      linkedin?: string
    }
  }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/author-profiles/${userId}`
    ),
    method: 'PATCH',
    headers: appApiHeaders(),
    body: data,
  })
)
